import GenericScreen from "../../../GenericScreen";
import AccessAlarmIcon from "@mui/icons-material/AccessAlarm";

import GenericPhoneScreen from "../../../GenericPhoneScreen";
import imgScreen from "../../../../../../Assets/StoryPassenger/PHONE_16.jpg";

import connectWithDispatch from "../../../../../../Hooks/connectWithDispatch";

interface ScreenProps {
  transition: number;
}

const Screen = (props: ScreenProps) => {
  const { transition } = props;

  return (
    <GenericScreen
      showComponent={transition >= 4}
      showContent={true}
      icon={<AccessAlarmIcon sx={styles.icon} />}
      title={"Realtime updates"}
      text={"Elena, you have a little time to kill at the airport now."}
      panelRight={<GenericPhoneScreen imgScreen={imgScreen} bottom={"27.01vh"} width={"33.3vh"} height={"5.1vh"} left={"3.6vh"} />}
    />
  );
};

const styles = {
  icon: {
    fontSize: "5.2083em",
    color: "#00B28F",
  },
};

const mapStateToProps = (state: StateType) => {
  return {
    transition: state.appReducer.story.transition,
  };
};

export default connectWithDispatch(Screen, mapStateToProps);
